// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__J7+qQ","skillsContainer":"Skills_skillsContainer__hNaVq","skillsElements":"Skills_skillsElements__JqWz-"};